import { BASIC_INITIAL_STATE } from '@usas/ui-web/utils/HttpHelper';

import getClubRegistrationStatus from './GetClubRegistrationStatusData';

const INITIAL_STATE = {
  ...BASIC_INITIAL_STATE
};

const ClubRegistrationStatusData = {
  INITIAL_STATE,
  getClubRegistrationStatus
};

export default ClubRegistrationStatusData;